import styled from 'styled-components';

import { Color, Gradient } from '../../../shared/constants/Colors';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const ContentContainer = styled.div`
    width 100%;
    padding-bottom: 30px;

    p {
        margin: 0;
    }
`;

export const AuthorContainer = styled.div`
  width: 100%;

  p {
    margin: 0;
  }
`;

export const Quote = styled.div`
  border-left: 5px solid;
  border-image: ${Gradient.BORDER_BLUE};
  padding: 30px;

  ${MediaQuery.S_AND_DOWN} {
    padding: 30px 0 15px 20px;
  }
`;

export const Content = styled.p`
  ${Typography.XXL};
  font-style: italic;
  color: ${Color.CLOUD_BURST};
`;
